exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.floatingNotificationsHolder[data-v-b2f5c1d2] {\n  position: fixed;\n  width: 320px;\n  top: 50px;\n  right: 25px;\n  z-index: 10;\n}\n.floatingNotificationsHolder .infoCard[data-v-b2f5c1d2] {\n    background-color: #fff;\n}\n.floatingNotificationsHolder .infoCard .date[data-v-b2f5c1d2] {\n      font-size: 12px;\n      font-style: italic;\n      line-height: 1.58;\n}\n.floatingNotificationsHolder .infoCard .infoContent[data-v-b2f5c1d2] {\n      line-height: 1.36;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-b2f5c1d2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/notifications/floatingNotifications/floatingNotifications.vue
// module id = 2337
// module chunks = 0